import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import * as styles from './TaxLabel.module.scss'

import { Icon } from '../../basics'
import { TaxModal } from '../../modals/TaxModal'
import { getTaxVariant } from '../Tax/utils'

type TaxLabelProps = {
  className?: string
  collectAccommodationTaxOnSite: boolean
  collectBathTaxOnSite: boolean
}

const labelKeyByVariant = {
  accommodation: 'accommodationTax',
  bath: 'bathingTax',
  both: 'accommodationAndBathingTax',
} as const

export const TaxLabel: React.FC<TaxLabelProps> = ({
  className,
  collectAccommodationTaxOnSite,
  collectBathTaxOnSite,
}) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'components.TaxLabel',
  })
  const [isOpen, setIsOpen] = useState(false)
  const variant = getTaxVariant(
    collectAccommodationTaxOnSite,
    collectBathTaxOnSite
  )

  const label = useMemo(() => {
    if (!variant) {
      return ''
    }

    return t(labelKeyByVariant[variant])
  }, [t, variant])

  if (!variant) {
    return null
  }

  return (
    <div className={clsx(styles.wrapper, className)}>
      <Icon mark="info">
        <button
          type="button"
          className={styles.link}
          onClick={() => {
            setIsOpen(true)
          }}
        >
          {label}
        </button>
      </Icon>
      <TaxModal
        isOpen={isOpen}
        showAccommodationTax={collectAccommodationTaxOnSite}
        showBathTax={collectBathTaxOnSite}
        onClose={() => {
          setIsOpen(false)
        }}
      />
    </div>
  )
}
